import { Controller } from "@hotwired/stimulus"

// registration LP の sticky <header> に scroll で shadow を on/off する controller (#1833 PR 7)。
//
// 元 inline JS は 3 ファイル (_layout_lp / steps/contact_info / steps/name_birthdate) に
// 重複 copy されており、関数名だけ違う本質同型のコード。Stimulus 化で 1 controller に集約。
//
// scope: `<header>` 要素に直接置く。`window.scroll` listener を connect で attach、
// disconnect で remove (Turbo Drive navigation 後の重複 attach を構造的に防止)。
export default class extends Controller {
  connect() {
    this.handleScroll = this.handleScroll.bind(this)
    window.addEventListener("scroll", this.handleScroll)
    this.handleScroll()
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll)
  }

  handleScroll() {
    if (window.scrollY > 10) {
      this.element.classList.add("shadow-md")
    } else {
      this.element.classList.remove("shadow-md")
    }
  }
}
